const SET_CHILD_PROJECTS = (state, projects) => {
  state.childProjects = projects;
};

const PUSH_CHILD_PROJECTS = (state, projects) => {
  if (!state.childProjects) {
    state.childProjects = [];
  }
  state.childProjects.push(...projects);
};

export default {
  SET_CHILD_PROJECTS,
  PUSH_CHILD_PROJECTS,
};
